import React from "react";
import { Modal, Icon } from "antd";
import ModalContentHolder from "./Styles/ModalContentStyle";
import { useTranslation } from "react-i18next";

const ModalChangeDates = ({ visible = false, onCancel }) => {
  const { t } = useTranslation();

  return (
    <>
      {visible &&
        <Modal
          title={<span style={{ fontWeight: "bold" }}>{t("Attention Outbound rules updated automatically")}</span>}
          visible={visible}
          onCancel={onCancel}
          footer={null}
          width={600}
        >
              <ModalContentHolder style={{ padding: "20px", marginBottom: "-16px" }}>
              <div style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginBottom: "16px"
                }}>
                  <Icon
                    type="warning"
                    theme="outlined"
                    style={{
                      color: "#ffc107",
                      fontSize: "48px"
                    }}
                  />
                </div>
                <p>{t("You've edited the campaign's start and end dates. If the campaign has output rules configured, the dates for those rules have been automatically adjusted to match the new range.")}</p>
                <p style={{ fontWeight: "bold" }}>{t("However, we recommend reviewing these rules manually to ensure they remain aligned with your campaign goals.")}</p>
              </ModalContentHolder>
        </Modal>
      }
    </>
  );
};

export default ModalChangeDates;